import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { ChangeTranscriptStatus } from './change-transcript-status.action';

export function changeTranscriptStatusReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<
        ActionType.COACHING__CA__CHANGE_TRANSCRIPT_STATUS,
        ChangeTranscriptStatus
    >,
): CaAnalysisDialogState {
    return {
        ...state,
        transcriptStatus: action.payload.status,
    };
}
